module.exports = __webpack_public_path__ + "img/lens-160-minus-04.e191f05c.png";